import Button from 'components/Button/Button'
import React from 'react'
import { BookingItemProps } from './BookingItem.props'
import {
  BookingItemContainer,
  BookingItemEditButton,
  BookingItemNotAvailable,
  BookingItemReserved,
  BookingItemReservedContainer,
  BookingItemTitle,
} from './BookingItem.styled'
import SVG from 'react-inlinesvg'
import dots from 'assets/icons/more-options.svg'
import { useAppState } from 'store'

import moment from 'moment'
import useBase64 from 'hooks/useBase64'

const BookingItem: React.FC<BookingItemProps> = ({
  allData,
  startTime,
  nextTime,
  available,
  bookingByMe,
  bookingNowData,
  price,
}) => {
  const token = useAppState(state => state.auth.token)
  const appointmentLocation = useAppState(state => state.appointments.location)

  const { encode } = useBase64()

  const goToBookScreen = () => {
    const paymentURL = process.env.REACT_APP_PAYMENT_URL
    const { date, court_id } = bookingNowData

    const courtId = court_id !== '' ? court_id : allData.court_ids[0]

    const initialTime = moment(date)
    const endTime = moment(date)
    const [startHour, startMinute] = startTime.split(':')
    const [endtHour, endtMinute] = nextTime.split(':')
    const period = startMinute.split(' ')[1]
    const momentStartTime = moment(
      `${startHour}:${startMinute} ${period}`,
      'h:mm a'
    )
    const momentEndTime = moment(
      `${endtHour}:${endtMinute} ${period}`,
      'h:mm a'
    )
    initialTime.set({
      hour: momentStartTime.get('hour'),
      minute: momentStartTime.get('minute'),
      second: 0,
    })
    endTime.set({
      hour: momentEndTime.get('hour'),
      minute: momentEndTime.get('minute'),
      second: 0,
    })

    const start_date = initialTime.format('YYYY-MM-DDTHH:mm:ss')
    const end_date = endTime.format('YYYY-MM-DDTHH:mm:ss')

    const body = {
      start_date,
      end_date,
      price,
      court_ids: [parseInt(courtId as string)],
    }

    const encodedToken = encode(token ?? '')
    const encodedBody = encode(`[${JSON.stringify(body)}]`)
    return (window.location.href = `${paymentURL}/api/v1/locations/${appointmentLocation?.id}/payments?authorization=${encodedToken}&appointments=${encodedBody}`)
  }

  return (
    <BookingItemContainer>
      <BookingItemTitle available={available}>
        {startTime} - {nextTime ? nextTime : '09:00pm'}
      </BookingItemTitle>
      {available && (
        <Button
          text="Book now"
          variant="primary"
          preset="filled"
          size={'medium'}
          onClick={goToBookScreen}
        />
      )}
      {!available && !bookingByMe && (
        <BookingItemNotAvailable>Not Available</BookingItemNotAvailable>
      )}

      {!available && bookingByMe && (
        <BookingItemReservedContainer>
          <BookingItemReserved>Reserved by you</BookingItemReserved>
          {/* <BookingItemEditButton style={{ marginLeft: 23 }}>
            <SVG src={edit} />
          </BookingItemEditButton> */}
          <BookingItemEditButton style={{ marginLeft: 16 }}>
            <SVG src={dots} />
          </BookingItemEditButton>
        </BookingItemReservedContainer>
      )}
    </BookingItemContainer>
  )
}

export default BookingItem
